import { queryGet, queryPost } from '@/api/apiConfig';

export default {
  getCategories () {
    return queryGet('/api/app/insertCategory/fullList');
  },

  getInsertsByCategory (categoryId) {
    return queryGet(`/api/app/insert/insertsByCategoryId/${categoryId}`);
  },

  getInsertById (insertId) {
    return queryGet(`/api/app/insert/${insertId}`);
  },

  saveApartInsert (data) {
    return queryPost('/api/app/insert/design', data);
  }
};
